export default __webpack_public_path__ + "static/media/black_chat_conv.39687cd8.svg";